<template>
  <div>
    <div class="container">
    </div>
    <article class="is-parent box">
    <h1 class="title has-text-centered">Per 60 Comparison Tool</h1>
    <season-totals-menu name="zone-starts"></season-totals-menu>
     <section id="gameFilters">
      <div class="is-parent  is-vertical">
      <article class="is-child box">
        <h2 class="subtitle"><b>Filters</b></h2>
          <div class="columns">
            <div class="column is-3">
              <label class="label">Season</label>
              <div class="control">
                <div class="select">
                  <select v-model="YearSelected" @change="fetchSeasonStats">
                    <option value=2022>2022-2023</option>
                    <option value=2019>2019-2020</option>
                    <option value=2018>2018-2019</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-3">
              <label class="label">Competition</label>
              <div class="control">
                <div class="select">
                  <select v-model="CompetitionSelected"  @change="fetchSeasonStats">
                    <option v-for="option in CompetitionOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
              <div class="column is-4">
                <label class="label">Opponent</label>
                <div class="control">
                  <div class="select">
                    <select  v-model="OpponentSelected"  @change="fetchSeasonStats">
                      <option v-for="option in OpponentOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
            <div class="column is-5">
              <label class="label">Venue</label>
              <div class="control">
                <div class="select">
                  <select v-model="VenueSelected"  @change="fetchSeasonStats">
                    <option v-for="option in VenueOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-4">
                <label class="label">Limit</label>
                <div class="control">
                  <div class="select">
                    <select v-model="LimitSelected" @change="fetchSeasonStats">
                      <option v-for="option in LimitOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                    </select>
                  </div>
                </div>
            </div>
          </div>
        </article>
      <data-table id="Filtered Games" heading="Filtered Games" v-bind:headers="FilterHeadings" v-bind:tableData="GameFilter"></data-table>
      </div>
    </section>
    </article>
   
    <section id="players">
        <div class="is-parent is-vertical">
            <div class="columns">
                <div class="column is-6">
                    <data-table defaultShow="true" id="Season Avg" heading="Season Average / Game" v-bind:headers="TableHeadings"
                        v-bind:tableData="sortByGameAverageData">
                        <template slot="filter">
                            <div class="columns">
                                <div class="column is-5">
                                    <label class="label">Statistic</label>
                                    <div class="control">
                                        <div class="select">
                                            <select v-model="StatSelected" @change="fetchSeasonStats">
                                                <option v-for="option in StatOptions" v-bind:value="option.value"
                                                    v-bind:key="option.value">{{option.text}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-5">
                                    <label class="label">Sort By</label>
                                    <div class="control">
                                        <div class="select">
                                            <select v-model="SortSelected">
                                                <option v-for="option in SortOptions" v-bind:value="option.value"
                                                    v-bind:key="option.value">{{option.text}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div slot="graph">
                        </div>
                    </data-table>
                </div>
                <div class="column is-6">
                    <data-table defaultShow="true" id="per_sixty" heading="Per Sixty Minutes" v-bind:headers="TableHeadings"
                        v-bind:tableData="sortByPerSixtyData">
                        <template slot="filter">
                            <div class="columns">
                                <div class="column is-5">
                                    <label class="label">Statistic</label>
                                    <div class="control">
                                        <div class="select">
                                            <select v-model="StatSelected" @change="fetchSeasonStats">
                                                <option v-for="option in StatOptions" v-bind:value="option.value"
                                                    v-bind:key="option.value">{{option.text}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-5">
                                    <label class="label">Sort By</label>
                                    <div class="control">
                                        <div class="select">
                                            <select v-model="SortSelected">
                                                <option v-for="option in SortOptions" v-bind:value="option.value"
                                                    v-bind:key="option.value">{{option.text}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div slot="graph">
                        </div>
                    </data-table>
                </div>
            </div>
        </div>
    </section>
    </div>
</template>
<script>
import DataTable from '../data-table'
import SubTable from '../sub-table'
import SeasonTotals from '../season-totals-menu'
import Chart from 'vue-bulma-chartjs'
import _ from 'lodash'
export default {
  components: {
    'data-table': DataTable,
    'sub-table': SubTable,
    'season-totals-menu': SeasonTotals,
    Chart
  },
  data () {
    return {
      GameFilter: [],
      CompetitionOptions: [],
      VenueOptions: [],
      OpponentOptions: [],
      StatOptions: [],
      PeriodOptions: [],
      LimitOptions: [],
      YearSelected: 2022,
      CompetitionSelected: 'EIHL_Challenge_Cup',
      VenueSelected: 0,
      OpponentSelected: 0,
      PeriodSelected: 0,
      StatSelected: 0,
      LimitSelected: 0,
      FilterSelected: 'Line',
      SeasonAverageData: [],
      SortOptions: [],
      SortSelected: 'GP',
      PerSixtyData: [],
      TableHeadings: [
        'Player',
        'GP'
      ],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      },
      lineOptions: {
        title: { display: false, text: 'Sessions By Platform' },
        scales: {
          xAxes: [{
            stacked: true,
            display: true,
            ticks: {
              autoSkip: false
            }
          }],
          yAxes: [{
            stacked: true,
            display: true
          }]
        },
        legend: {
          display: true,
          labels: {
            fontColor: 'rgb(255, 99, 132)'
          }
        }
      }
    }
  },
  computed: {
    sortByGameAverageData: function () {
      console.log('Sort selected: ' + this.SortSelected)
      return _.orderBy(this.SeasonAverageData, this.SortSelected, ['desc'])
    },
    sortByPerSixtyData: function () {
      console.log('Sixty Sort selected: ' + this.SortSelected)
      return _.orderBy(this.PerSixtyData, this.SortSelected, ['desc'])
    },
    sortByZoneStartsDataChart: function () {
      let orderedData = this.sortByZoneStartsData
      return _.map(orderedData, this.FilterSelected)
    },
    sortLineData: function () {
      return _.orderBy(this.SeasonAverageData, ['defensive_percent', 'neutral_percent', 'offensive_percent'], ['asc', 'asc', 'asc'])
    },
    chartData: function () {
      console.log(this.FilterSelected)
      if (this.FilterSelected === 'Line') {
        console.log('Doing line')
        let playerLabels = []
        for (var lineLabel of this.sortLineData) {
          playerLabels.push(lineLabel.player)
        }
        let offensive = []
        let neutral = []
        let defensive = []
        for (var d of this.sortLineData) {
          offensive.push(d.offensive_percent)
          neutral.push(d.neutral_percent)
          defensive.push(d.defensive_percent)
        }
        let data = {
          labels: playerLabels
        }
        data.datsets = []
        data.datasets = [{
          data: offensive,
          label: 'Offensive',
          backgroundColor: '#42c3ff',
          borderColor: '#42c3ff'
        },
        {
          data: neutral,
          label: 'Neutral',
          backgroundColor: '#FEBC38',
          borderColor: '#FEBC38'
        },
        {
          data: defensive,
          label: 'Defensive',
          backgroundColor: '#CA3542',
          borderColor: '#CA3542'
        }]
        return data
      } else {
        let playerLabels = []
        for (var label of this.sortByZoneStartsData) {
          playerLabels.push(label.player)
        }
        let data = {
          labels: playerLabels
        }
        data.datsets = []
        data.datasets = [{
          data: this.sortByZoneStartsDataChart,
          label: 'Zone Start - ' + this.FilterSelected,
          backgroundColor: 'rgba(54, 162, 235, 1)',
          borderColor: 'rgba(54, 162, 235, 1)'
        }]
        return data
      }
    }
  },
  methods: {
    fetchSeasonStats () {
      let postData = {
        'year': 2019,
        'competition': this.CompetitionSelected,
        'venue': this.VenueSelected,
        'opponent': this.OpponentSelected,
        'situation': this.StatSelected,
        'category': this.StatSelected,
        'limit': this.LimitSelected
      }
      console.log('Filter: ' + JSON.stringify(postData))
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/season-stats/per-sixty', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        })
        .then(
          response => {
            console.log(response.data)
            this.GameFilter = response.data.games_filter
            this.SeasonAverageData = response.data.season_average
            this.PerSixtyData = response.data.per_sixty
            if (this.StatSelected === 0) {
              let goalHeading = [
                'Player',
                'GP',
                'Goals',
                'Primary Assists',
                'Secondary Assists',
                'Total Assists',
                'Points',
                'Primary Points'
              ]
              this.TableHeadings = goalHeading
              this.SortOptions = []
              this.SortOptions.push({text: 'Goals', value: 'goals'})
              this.SortOptions.push({text: 'Primary Assists', value: 'first_assist'})
              this.SortOptions.push({text: 'Second Assists', value: 'second_assist'})
              this.SortOptions.push({text: 'Total Assists', value: 'total_assist'})
              this.SortOptions.push({text: 'Total Points', value: 'total_points'})
              this.SortOptions.push({text: 'Primary Points', value: 'primary_points'})
            } else {
              let shotsHeading = [
                'Player',
                'GP',
                'SOT',
                'Missed Shots',
                'Blocked Shots'
              ]
              this.TableHeadings = shotsHeading
            }
          },
          response => {}
        )
    },
    fetchFilterOptions () {
      this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
      }).then(
          response => {
            // console.log(response.data)
            let venue = response.data.venue
            this.VenueOptions.push({text: 'All', value: 0})
            for (var i = 0; i < venue.length; i++) {
              this.VenueOptions.push({text: venue[i].location, value: venue[i].location})
            }
            let opponent = response.data.teams
            this.OpponentOptions.push({text: 'All', value: 0})
            for (var j = 0; j < opponent.length; j++) {
              if (opponent[j].id !== '1') {
                this.OpponentOptions.push({text: opponent[j].name, value: opponent[j].id})
              }
            }
            // let situations = response.data.situations
            this.StatOptions.push({text: 'Goals & Points', value: 0})
            this.StatOptions.push({text: 'Shots', value: 1})

            this.CompetitionOptions.push({text: 'All', value: 0})
            this.CompetitionOptions.push({text: 'EIHL & Challenge Cup', value: 'EIHL_Challenge_Cup'})
            this.CompetitionOptions.push({text: 'EIHL', value: 'EIHL'})
            this.CompetitionOptions.push({text: 'Challenge Cup', value: 'Challenge-Cup'})
            this.CompetitionOptions.push({text: 'Pre-Season', value: 'Pre-Season'})
            this.CompetitionOptions.push({text: 'Playoffs', value: 'Playoffs'})
            this.CompetitionOptions.push({text: 'CHL', value: 'CHL'})

            this.PeriodOptions.push({text: 'All', value: 0})
            this.PeriodOptions.push({text: 'Period 1', value: 1})
            this.PeriodOptions.push({text: 'Period 2', value: 2})
            this.PeriodOptions.push({text: 'Period 3', value: 3})
            this.PeriodOptions.push({text: 'Period OT', value: 4})
            this.PeriodOptions.push({text: 'Period Shootout', value: 5})

            this.LimitOptions.push({text: 'All', value: 0})
            this.LimitOptions.push({text: '5 Games', value: 5})
            this.LimitOptions.push({text: '10 Games', value: 10})
            this.LimitOptions.push({text: '20 Games', value: 20})
          }
        )
    }
  },
  created () {
    this.fetchSeasonStats()
    this.fetchFilterOptions()
  }
}
</script>
<style>
#fixed-div {
    position: fixed;
    top: 1em;
    right: 1em;
}
</style>



// WEBPACK FOOTER //
// per-sixty.vue?5bd268aa